import { Directive, ElementRef, Input, OnInit, Renderer2 } from '@angular/core';

/**
 * Directive that adds an animated gradient border to the host element.
 * Uses the pseudo-element technique for broad browser support.
 *
 * For ion-card: wrap the card in a div with the directive so the border is visible
 * (ion-card's internal background can cover the effect otherwise). Example:
 *
 *   <div appAnimatedBorder class="animated-border-wrapper">
 *     <ion-card style="--background: transparent">...</ion-card>
 *   </div>
 *
 * Or use on a plain div/container; then the inner fill uses --animated-border-inner-bg.
 *
 * Customize via CSS variables: --animated-border-color-start, --animated-border-color-end,
 * --animated-border-inner-bg, --animated-border-width, --animated-border-radius, --animated-border-duration.
 */
@Directive({
  selector: '[appAnimatedBorder]',
  standalone: true,
})
export class AnimatedBorderDirective implements OnInit {
  @Input() appAnimatedBorder: boolean | '' = true;

  constructor(
    private el: ElementRef<HTMLElement>,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    if (this.appAnimatedBorder === false) {
      return;
    }
    this.renderer.addClass(this.el.nativeElement, 'app-animated-border');
  }
}
